function e(t, s, i) {
  const r = t.prerender;
  t.prerender = function(...n) {
    i.value.apply(this, n), r.apply(this, n);
  };
}
function p(t, s, i) {
  const r = t.postrender;
  t.postrender = function(...n) {
    i.value.apply(this, n), r.apply(this, n);
  };
}
function o(t, s, i) {
  const r = t.destroy;
  t.destroy = function(...n) {
    i.value.apply(this, n), r.apply(this, n);
  };
}
const a = (t) => (s) => {
  s.mixins && Array.isArray(s.mixins) && (s.mixins = [...s.mixins, t]);
};
export {
  a,
  e,
  o as r,
  p as y
};
